<template>
    <div
        class="px-3 tablet-sm:px-4 bg-blue-100 border border-blue-400 text-blue-700 rounded relative my-4 py-3 flex items-center"
        role="alert"
    >
        <InformationCircleIcon class="mr-0 tablet-sm:mr-2 relative h-6 w-6 min-w-8
                                     hidden tablet-sm:inline-block
                                     " aria-hidden="true" />
        <p class="text-base"><slot></slot></p>
    </div>
</template>
<script setup>
import { InformationCircleIcon } from "@heroicons/vue/24/outline";
</script>
